/* eslint-disable react/display-name */
/* eslint-disable react/react-in-jsx-scope */
import * as Yup from 'yup';
import { role } from 'config/role';

export const SETTING_UPDATE = 'Settings updated successfully.';

export const FREEZE_STATUS = {
  UNFREEZE: 'UnFreeze',
  FREEZE: 'Freeze',
};

export const termsValidationSchema = Yup.object().shape({
  settingValue: Yup.string().required('Terms is required').trim(),
});

export const privacyValidationSchema = Yup.object().shape({
  settingValue: Yup.string().required('Privacy policy is required').trim(),
});

export const freezeMarketValidation = Yup.object().shape({
  freezeReason: Yup.string('Enter the Message')
    .max(200, 'Message should be less than 200 characters')
    .trim(),
  // freezeReason: Yup.string().when('freezeStatus', {
  //   is: true,
  //   then: Yup.string(), // No validation when freezeStatus is true
  //   otherwise: Yup.string().required('Freeze Reason is required').trim(),
  // }),
});

export const userVerificationDocumentValidationSchema = Yup.object().shape({
  USER_VERIFICATION_DOCUMENT: Yup.mixed()
    .required('Verification Document is required')
    .test(
      'fileType',
      'Only PDF file is allowed',
      (value) => value && value.includes('.pdf'),
    ),
});

export const columns = [
  {
    accessorKey: 'seller',
    header: 'COUPON CODE',
    cell: () => <div className="px-1">HS3409</div>,
    sort: true,
  },
  {
    accessorKey: 'grade.name',
    header: 'GRADE',
    sort: true,
  },
  {
    accessorKey: 'rate',
    header: 'PRICE',
    sort: true,
  },
  { accessorKey: 'date', header: 'DATE', sort: true },
];

export const applicationUIList = {
  Images: 'Images',
  PromotionalImages: 'Banner',
  Banner: 'Banner',
  Text: 'Text',
  TermsAndConditions: 'Terms and Conditions',
  AboutUs: 'About Us',
  PrivacyPolicy: 'Privacy Policy',
  MarketFreeze: 'Market Freeze',
  DOWNLOAD_APK: 'Download APK',
  FAQ: 'FAQ',
  NEWS: 'News',
  USER_VERIFICATION_DOCUMENT: 'Verification Document',
};

export const FAQ_TYPES = {
  INDIAN_FAQ: 'INDIAN_FAQ',
  FOREIGN_FAQ: 'FOREIGN_FAQ',
};
export const promotionTypes = [
  { id: 'banner', label: 'BANNER' },
  { id: 'ADVT', label: 'ADVERTISEMENT' },
];

export const bannerCategoryOptions = [
  { id: 'HOME_TOP_BANNER', label: 'Home Banner (Website only)' },
  {
    id: 'HOME_LANDSCAPE_BANNER',
    label: 'Home Landscape Banner (Website and App)',
  },
  { id: 'MARKETPLACE_BANNER', label: 'Marketplace Banner (Website only)' },
];

export const applicationUITabHeading = [
  {
    link: 'Download APK',
    allowedRoles: [role.SUPER_ADMIN, role.SALES_HEAD],
  },
  {
    link: 'FAQ',
    allowedRoles: [role.SUPER_ADMIN, role.SALES_HEAD],
  },
  {
    link: 'Banner',
    allowedRoles: [role.SUPER_ADMIN, role.SALES_HEAD],
  },
  {
    link: 'Terms and Conditions',
    allowedRoles: [role.SUPER_ADMIN],
  },
  {
    link: 'About Us',
    allowedRoles: [role.SUPER_ADMIN],
  },
  {
    link: 'Privacy Policy',
    allowedRoles: [role.SUPER_ADMIN],
  },
  {
    link: 'Market Freeze',
    allowedRoles: [role.SUPER_ADMIN, role.SALES_HEAD],
  },

  {
    link: 'Verification Document',
    allowedRoles: [role.SUPER_ADMIN],
  },
  {
    link: 'News',
    allowedRoles: [role.SUPER_ADMIN],
  },
];

export const APP_UI = {
  PROMO_IMAGE: 'PROMO_IMAGE',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  ABOUT_US: 'ABOUT_US',
  TERMS_OF_USE: 'TERMS_OF_USE',
  NEWS: 'NEWS',
  USER_VERIFICATION_DOCUMENT: 'USER_VERIFICATION_DOCUMENT',
};

export const bannerValidationSchema = Yup.object().shape({
  promotionType: Yup.object('')
    .required('Banner type/category is required')
    .nullable(),
  imageUrl: Yup.mixed()
    .required('Banner image is required')
    .test('fileType', 'Only JPG, JPEG, PNG, GIF files are allowed', (value) => {
      if (!value) return false;

      const allowedExts = ['.png', '.jpg', '.jpeg', '.gif'];
      const hasAllowedExtension = (name) => {
        if (!name) return false;
        const clean = String(name).split('?')[0].toLowerCase();
        return allowedExts.some((ext) => clean.endsWith(ext));
      };

      // If a File object is passed, validate by MIME type or filename.
      if (typeof File !== 'undefined' && value instanceof File) {
        const mimeType = String(value.type || '').toLowerCase();
        if (mimeType.startsWith('image/')) return true;
        return hasAllowedExtension(value.name);
      }

      // For uploaded URLs, allow if it has a known image extension.
      if (typeof value === 'string') {
        if (hasAllowedExtension(value)) return true;

        // If URL/path has no extension (common for blob/storage URLs), allow it.
        const clean = value.split('?')[0];
        const hasAnyExtension = /\.[a-z0-9]+$/i.test(clean);
        return !hasAnyExtension;
      }

      return false;
    }),
  redirectUrl: Yup.string()
    .url('Enter a valid URL')
    .transform((value) => (value === '' ? null : value))
    .nullable(),
});

export const extractColoredCells = (bannerPositions = []) => {
  const coloredCells = [];
  bannerPositions.forEach((position) => {
    coloredCells.push({
      R: position.rowIndex,
      C: position.columnIndex,
    });
  });

  return coloredCells;
};
